import { render, staticRenderFns } from "./Triangles.vue?vue&type=template&id=092d43b8&scoped=true&"
import script from "./Triangles.vue?vue&type=script&lang=js&"
export * from "./Triangles.vue?vue&type=script&lang=js&"
import style0 from "./Triangles.vue?vue&type=style&index=0&id=092d43b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d43b8",
  null
  
)

export default component.exports